import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Wordmark } from "@/components/landing/Wordmark";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404: rota inexistente", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-50 px-5">
      <Wordmark to="/" size="md" />
      <h1 className="mt-8 text-h1 text-neutral-900">Essa página não existe</h1>
      <p className="mt-2 max-w-sm text-center text-body text-neutral-500">
        O link pode ter mudado. Volte para o início e continue o ensaio.
      </p>
      <Button asChild className="mt-6">
        <Link to="/">Voltar ao início</Link>
      </Button>
    </div>
  );
};

export default NotFound;
